import type { ComponentType } from 'react'
import type { DjayIllustrationProps } from './types'

// Onboarding
import { FirstStepsIllustration } from './achievements/FirstStepsIllustration'
import { GettingStartedIllustration } from './achievements/GettingStartedIllustration'
import { CenturyIllustration } from './achievements/CenturyIllustration'
import { QuarterThousandIllustration } from './achievements/QuarterThousandIllustration'
import { HalfThousandIllustration } from './achievements/HalfThousandIllustration'
import { MillenniumIllustration } from './achievements/MillenniumIllustration'

// Streaks
import { ThreeDaysIllustration } from './achievements/ThreeDaysIllustration'
import { WeekChampionIllustration } from './achievements/WeekChampionIllustration'
import { FireMasterIllustration } from './achievements/FireMasterIllustration'
import { HotStreakIllustration } from './achievements/HotStreakIllustration'
import { TwoWeeksIllustration } from './achievements/TwoWeeksIllustration'
import { UnstoppableIllustration } from './achievements/UnstoppableIllustration'
import { LegendaryStreakIllustration } from './achievements/LegendaryStreakIllustration'
import { UnbreakableIllustration } from './achievements/UnbreakableIllustration'

// Mastery
import { FirstSubjectIllustration } from './achievements/FirstSubjectIllustration'
import { ThreeSubjectsIllustration } from './achievements/ThreeSubjectsIllustration'
import { AllSubjectsIllustration } from './achievements/AllSubjectsIllustration'

// Levels
import { Level3Illustration } from './achievements/Level3Illustration'
import { Level5Illustration } from './achievements/Level5Illustration'
import { Level7Illustration } from './achievements/Level7Illustration'
import { Level10Illustration } from './achievements/Level10Illustration'
import { Level12Illustration } from './achievements/Level12Illustration'
import { Level15Illustration } from './achievements/Level15Illustration'

// Special
import { ShadowRealmIllustration } from './achievements/ShadowRealmIllustration'
import { GoalGetterIllustration } from './achievements/GoalGetterIllustration'
import { ConsistentIllustration } from './achievements/ConsistentIllustration'
import { DailyMasterIllustration } from './achievements/DailyMasterIllustration'
import { PerfectionistIllustration } from './achievements/PerfectionistIllustration'
import { FlawlessIllustration } from './achievements/FlawlessIllustration'
import { UntouchableIllustration } from './achievements/UntouchableIllustration'
import { RainbowIllustration } from './achievements/RainbowIllustration'

export * from './types'
export * from './DjayIllustrationBase'

// Registry mapping achievement IDs to their specific illustrations
const ILLUSTRATION_REGISTRY: Record<
  string,
  ComponentType<DjayIllustrationProps>
> = {
  // Onboarding
  'first-steps': FirstStepsIllustration,
  'getting-started': GettingStartedIllustration,
  century: CenturyIllustration,
  'quarter-thousand': QuarterThousandIllustration,
  'half-thousand': HalfThousandIllustration,
  millennium: MillenniumIllustration,

  // Streaks
  'three-days': ThreeDaysIllustration,
  'week-champion': WeekChampionIllustration,
  'fire-master': FireMasterIllustration,
  'hot-streak': HotStreakIllustration,
  'two-weeks': TwoWeeksIllustration,
  unstoppable: UnstoppableIllustration,
  'legendary-streak': LegendaryStreakIllustration,
  unbreakable: UnbreakableIllustration,

  // Mastery
  'first-subject': FirstSubjectIllustration,
  'three-subjects': ThreeSubjectsIllustration,
  'all-subjects': AllSubjectsIllustration,

  // Levels
  'level-3': Level3Illustration,
  'level-5': Level5Illustration,
  'level-7': Level7Illustration,
  'level-10': Level10Illustration,
  'level-12': Level12Illustration,
  'level-15': Level15Illustration,

  // Special
  'shadow-realm': ShadowRealmIllustration,
  'goal-getter': GoalGetterIllustration,
  consistent: ConsistentIllustration,
  'daily-master': DailyMasterIllustration,
  perfectionist: PerfectionistIllustration,
  flawless: FlawlessIllustration,
  untouchable: UntouchableIllustration,
  'rainbow-djay': RainbowIllustration,
}

/**
 * Returns the specific illustration component for an achievement, or null if not implemented yet.
 */
export function getAchievementIllustration(
  achievementId: string,
): ComponentType<DjayIllustrationProps> | null {
  return ILLUSTRATION_REGISTRY[achievementId] || null
}
